import {AccountTypeEnum} from "../../enums/Accounting/AccountTypeEnum";
import {BaseCatalogDto} from "../catalogs/BaseCatalogDto";
import {AccountAnalyticTypeEnum} from "../../enums/Accounting/AccountAnalyticTypeEnum";

export enum ChartAccountStatusTypeEnum {
    active = 0,
    Passive = 1,
}

// export enum IsChartAccountQuantity {
//     yes = 0,
//     no = 1,
// }
//
// export enum isChartAccountAmount {
//     yes = 0,
//     no = 1,
// }
//
// export enum isChartAccountCurrency {
//     yes = 0,
//     no = 1,
// }

export interface IAccountDto extends BaseCatalogDto {
    id: string;
    accountNo: string;
    accountType: AccountTypeEnum;
    isCurrency: boolean;
    isAmount: boolean;
    isQuantity: boolean;
    isBalance: boolean;
    typeOfAnalytics1Name?: AccountAnalyticTypeEnum;
    typeOfAnalytics2Name?: AccountAnalyticTypeEnum;
    typeOfAnalytics3Name?: AccountAnalyticTypeEnum;
    parentId?: string | null;
    // children?: IAccountDto[];
}

export interface IAccountInfoDto {
    id?: string;
    isGroup: boolean;
    accountNo: string;
    name: string;
    accountType: number;
    isCurrency: boolean;
    isAmount: boolean;
    isQuantity: boolean;
    isBalance: boolean;
    typeOfAnalytics1: number;
    typeOfAnalytics2: number;
    typeOfAnalytics3: number
}
